import type { PunchWorkflowRun, WorkflowAreaTagLocation } from '../types';
import { formatUnitLabel } from '../types';

export const findWorkflowRunAreaTag = (
  run: PunchWorkflowRun,
  areaTags: WorkflowAreaTagLocation[],
): WorkflowAreaTagLocation | null => {
  const photoId = run.hotspot?.photo_id;
  if (!photoId) return null;
  return areaTags.find((areaTag) => areaTag.photo_ids.includes(photoId)) ?? null;
};

export const workflowRunLocationLabel = (
  run: PunchWorkflowRun,
  areaTags: WorkflowAreaTagLocation[] = [],
  currentHotspotId?: number,
): string => {
  if (run.location) return formatUnitLabel(run.location);

  const areaTag = findWorkflowRunAreaTag(run, areaTags);
  if (areaTag) return areaTag.name;

  if (run.hotspot?.id === currentHotspotId) return 'This hotspot';
  if (run.hotspot) return `Hotspot #${run.hotspot.id}`;
  return 'Location not listed';
};
